export default __webpack_public_path__ + "static/media/session-timeout.292d6a3d.svg";